module.exports = __webpack_public_path__ + "img/chin.1c7a859d.svg";